<script setup>
import { ref, onMounted } from 'vue';
import { copyToClipboard } from "@/utils";
import { useVideoCallState } from "@/stores/videoCallState";
import i18n from "@/i18n";
import axios from "axios";
import configurationProvider from "@/Core/configurationProvider";
import { EventManager } from "@events";

const props = defineProps({
  rtcId: {
    type: String,
    required: true,
  },

  // Adding this will prevent a vue.js warning
  sectionType: {
    type: String,
    required: false,
  },

  // Adding this will prevent a vue.js warning
  modelValue: {
    type: Object,
    required: false
  }
});

const actionEmitter = EventManager.getActionEmitter(props.rtcId);

const LOCAL_URL_BASE = configurationProvider.getString("LOCAL_URL_BASE", undefined) || undefined;
const url = new URL(`/admin/whisper/join/${props.rtcId}`, LOCAL_URL_BASE ?? window.location.origin).toString();
let tinyurl = undefined;
const isDialogVisible = ref(false);
const dialogText = ref('');

const copyToClipboardBtnClass = ref('btn-primary');
const copyToClipboardBtnText = ref(i18n.global.t("Copy"));

onMounted(() => {
  actionEmitter.on("open-whisper-url-share-dialog", () => {
    openUrlShareDialog();
  });
});

async function openUrlShareDialog(){
  if(!LOCAL_URL_BASE){
    copyToClipboardBtnClass.value = 'd-none';
    dialogText.value = i18n.global.t("LocalURLBaseNotSet");
    isDialogVisible.value = true;
    console.error(i18n.global.t("LocalURLBaseNotSet"));
    return;
  }

  if(!tinyurl){
    try {
      const response = await axios.post('/api/TinyUrl/Generate', { url });
      tinyurl = response?.data?.tinyurl;
      if(!tinyurl){
        console.error("Failed to generate tiny url", response.data);
      }
    }
    catch(error){
      console.error(error);
    }
  }

  copyToClipboardBtnClass.value = 'btn-primary';
  copyToClipboardBtnText.value = i18n.global.t("Copy");

  if(tinyurl) dialogText.value = tinyurl;
  else dialogText.value = url;

  isDialogVisible.value = true;
}

async function copyToClipboardBtnClick(text){
  if(text && await copyToClipboard(text)){
    copyToClipboardBtnClass.value = 'btn-success';
    copyToClipboardBtnText.value = i18n.global.t("Copied");
  }
  else {
    copyToClipboardBtnClass.value = 'btn-danger';
    copyToClipboardBtnText.value = i18n.global.t("CopyFailed");
  }
}

</script>
  
<template>
  <v-dialog v-model="isDialogVisible" max-width="800">
    <v-card class="pt-1">
      <v-card-text style="text-align: center; font-size: 17px;">
        <span style="color: #3085d6">{{ $t("SupervisorLink") }}&nbsp;</span>{{ dialogText }}
        <button :class="copyToClipboardBtnClass" class="btn ml-1 mb-1" @click="copyToClipboardBtnClick(dialogText)">
          <i class="mdi mdi-content-copy"></i> {{ copyToClipboardBtnText }}
        </button>
      </v-card-text>
      <v-card-actions>
        <v-btn color="info" @click="isDialogVisible = false">{{ $t("Close") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
  